"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var Hit_1 = __importDefault(require("./Hit"));
var CurrentRefinements_1 = __importDefault(require("./CurrentRefinements"));
var Menu_1 = __importDefault(require("./Menu"));
var react_1 = __importStar(require("react"));
var lite_1 = __importDefault(require("algoliasearch/lite"));
var react_router_dom_1 = require("react-router-dom");
var qs_1 = __importDefault(require("qs"));
var translator_1 = require("../translations/translator");
var leaflet_geosearch_1 = require("leaflet-geosearch");
var turf_1 = require("@turf/turf");
var lodash_1 = require("lodash");
var RefinementList_1 = __importDefault(require("./RefinementList"));
var searchClient = lite_1.default(window.Algolia.app_id, window.Algolia.search_key);
var categories = {
    'premium-living': translator_1.translate('premium-living'),
    'woonzorgcentrum': translator_1.translate('woonzorgcentrum'),
    'assistentiewoningen': translator_1.translate('assistentiewoningen'),
    'dringende-opname': translator_1.translate('dringende-opname'),
    'kortverblijf': translator_1.translate('kortverblijf'),
    'herstelverblijf': translator_1.translate('herstelverblijf'),
    'tijdelijk-verblijf': translator_1.translate('tijdelijk-verblijf'),
};
var states = {
    'Antwerpen': translator_1.translate('Antwerpen'),
    'Brussel': translator_1.translate('Brussel'),
    'Henegouwen': translator_1.translate('Henegouwen'),
    'Limburg': translator_1.translate('Limburg'),
    'Luik': translator_1.translate('Luik'),
    'Luxemburg': translator_1.translate('Luxemburg'),
    'Namen': translator_1.translate('Namen'),
    'Oost-Vlaanderen': translator_1.translate('Oost-Vlaanderen'),
    'Vlaams-Brabant': translator_1.translate('Vlaams-Brabant'),
    'Waals-Brabant': translator_1.translate('Waals-Brabant'),
    'West-Vlaanderen': translator_1.translate('West-Vlaanderen'),
};
// Returns a slug from the category name.
// Spaces are replaced by "+" to make
// the URL easier to read and other
// characters are encoded.
function getSlug(name) {
    return name
        .split(' ')
        .map(encodeURIComponent)
        .join('+');
}
var createURL = function (state, path) {
    var isDefaultRoute = !state.query &&
        state.page === 1 &&
        (state.menu && !state.menu.residence_categories && !state.menu.state);
    document.title = translator_1.translate(':type :province - Vind een :type in :province', {
        /* @ts-ignore */
        type: categories[state.menu.residence_categories] || translator_1.translate('Woonoplossingen'),
        /* @ts-ignore */
        province: states[state.menu.state] || translator_1.translate('België'),
    });
    var descriptionElement = document.getElementById('search-description');
    if (descriptionElement) {
        var type = state.menu.residence_categories === 'assistentiewoningen'
            ? translator_1.translate('assistentiewoning')
            // @ts-ignore
            : (categories[state.menu.residence_categories] || translator_1.translate('woonoplossing')).toLowerCase();
        descriptionElement.innerHTML = translator_1.translate('Zoek een :type in :province', {
            /* @ts-ignore */
            type: type,
            /* @ts-ignore */
            province: states[state.menu.state] || translator_1.translate('België'),
        });
    }
    if (isDefaultRoute) {
        return path;
    }
    var categoryPath = state.menu.residence_categories
        /* @ts-ignore */
        ? getSlug(categories[state.menu.residence_categories].toLowerCase()) + '/'
        : (state.menu.state ? getSlug(window.__('woonoplossingen')) + '/' : '');
    var statePath = state.menu.state
        /* @ts-ignore */
        ? getSlug(states[state.menu.state].toLowerCase())
        : '';
    var queryParameters = {};
    if (state.query) {
        queryParameters.query = encodeURIComponent(state.query);
    }
    if (state.page !== 1) {
        queryParameters.page = state.page;
    }
    var queryString = qs_1.default.stringify(queryParameters, {
        addQueryPrefix: true,
        arrayFormat: 'repeat',
    });
    return path + "/q/" + categoryPath + statePath + queryString;
};
var searchStateToUrl = function (searchState, path) {
    return searchState ? createURL(searchState, path) : '';
};
var urlToSearchState = function (location, path) {
    var _a;
    var pathnameMatches = (_a = location.pathname.replace(path, '').match(/([^\/]*)/g)) === null || _a === void 0 ? void 0 : _a.filter(function (m) { return m !== ''; });
    var category = '';
    if (pathnameMatches && pathnameMatches[1]) {
        category = pathnameMatches[1];
        if (category === getSlug(window.__('woonoplossingen'))) {
            category = '';
        }
        else {
            /* @ts-ignore */
            var index = Object.values(categories).findIndex(function (c) { return getSlug(c.toLowerCase()) === getSlug(category.replaceAll('+', ' ')); });
            if (index !== -1) {
                category = Object.keys(categories)[index];
            }
        }
    }
    var state = '';
    if (pathnameMatches && pathnameMatches[2]) {
        state = pathnameMatches[2];
        /* @ts-ignore */
        var index = Object.values(states).findIndex(function (s) { return getSlug(s.toLowerCase()) === getSlug(state.replaceAll('+', ' ')); });
        if (index !== -1) {
            state = Object.keys(states)[index];
        }
    }
    var _b = qs_1.default.parse(location.search.slice(1)), _c = _b.query, query = _c === void 0 ? '' : _c, _d = _b.page, page = _d === void 0 ? 1 : _d;
    return {
        query: decodeURIComponent(query.toString()),
        page: page,
        menu: {
            residence_categories: decodeURIComponent(category),
            state: decodeURIComponent(state),
        },
    };
};
var CustomGeoSearch = react_instantsearch_dom_1.connectGeoSearch(function (_a) {
    var hits = _a.hits, currentRefinement = _a.currentRefinement, refine = _a.refine;
    var _b = react_1.useState(''), value = _b[0], setValue = _b[1];
    react_1.useEffect(lodash_1.debounce(function () {
        if (!value) {
            // @ts-ignore
            refine(undefined);
            return;
        }
        var provider = new leaflet_geosearch_1.OpenStreetMapProvider();
        provider.search({ query: value + ', Belgium' }).then(function (results) {
            results = results.filter(function (result) { return ['boundary', 'place'].includes(result.raw.class); });
            if (!results.length) {
                // @ts-ignore
                refine(undefined);
                return;
            }
            var center = turf_1.point([results[0].y, results[0].x]);
            var buffered = turf_1.buffer(center, 20, { units: 'kilometers' });
            var boundingBox = turf_1.bbox(buffered);
            refine({
                northEast: { lat: boundingBox[0], lng: boundingBox[3] },
                southWest: { lat: boundingBox[2], lng: boundingBox[1] },
            });
        });
    }, 500), [value]);
    return (react_1.default.createElement("input", { id: "geo-search-input", className: "ais-SearchBox-input mt-2", defaultValue: value, placeholder: window.__('Gemeente'), onChange: function (event) {
            setValue(event.target.value);
        } }));
});
function SearchIndex(_a) {
    var children = _a.children, path = _a.path, _b = _a.latlng, latlng = _b === void 0 ? null : _b;
    return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(react_router_dom_1.Route, { path: path, component: function (_a) {
                var location = _a.location, history = _a.history;
                var _b = react_1.useState(urlToSearchState(location, path)), searchState = _b[0], setSearchState = _b[1];
                var _c = react_1.useState(undefined), debouncedSetState = _c[0], setDebouncedSetState = _c[1];
                var onSearchStateChange = function (updatedSearchState) {
                    clearTimeout(debouncedSetState);
                    setDebouncedSetState(setTimeout(function () {
                        history.push(searchStateToUrl(updatedSearchState, path), updatedSearchState);
                    }, 700));
                    setSearchState(updatedSearchState);
                };
                var params = new URLSearchParams(location.search);
                console.log(searchState);
                return (react_1.default.createElement(react_instantsearch_dom_1.InstantSearch, { searchClient: searchClient, indexName: window.Algolia.index_name, searchState: searchState, onSearchStateChange: onSearchStateChange, createURL: createURL },
                    react_1.default.createElement(react_instantsearch_dom_1.Configure, { filters: "locale:" + window.locale + " AND published:true", hitsPerPage: 100, aroundLatLngViaIP: !latlng, aroundLatLng: latlng ? latlng.lat + ', ' + latlng.lng : '' }),
                    react_1.default.createElement("div", { className: "grid gap-8 lg:grid-cols-3 xl:grid-cols-4" },
                        react_1.default.createElement("aside", { className: "bg-gray-100 p-6" },
                            react_1.default.createElement(react_instantsearch_dom_1.SearchBox, { translations: {
                                    placeholder: window.__('Residentie...'),
                                } }),
                            react_1.default.createElement(CustomGeoSearch, null),
                            params.has('search') && (react_1.default.createElement("p", { className: 'text-xs mt-4' },
                                window.__('Gesorteerd op afstand van'),
                                ": ",
                                params.get('search'))),
                            react_1.default.createElement("div", { className: "my-4" },
                                react_1.default.createElement("h4", { className: "mb-2 font-medium text-xs uppercase text-gray-500" }, window.__('Woonoplossingen')),
                                react_1.default.createElement(Menu_1.default, { attribute: "residence_categories" })),
                            react_1.default.createElement("div", { className: "my-4" },
                                react_1.default.createElement("h4", { className: "mb-2 font-medium text-xs uppercase text-gray-500" }, window.__('Provincie')),
                                react_1.default.createElement(Menu_1.default, { attribute: "state" })),
                            searchState.menu.residence_categories && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("div", { className: "my-4" },
                                    react_1.default.createElement("h4", { className: "mb-2 font-medium text-xs uppercase text-gray-500" }, window.__('Voorzieningen')),
                                    react_1.default.createElement(RefinementList_1.default, { attribute: "facilities" })),
                                react_1.default.createElement("div", { className: "my-4" },
                                    react_1.default.createElement("h4", { className: "mb-2 font-medium text-xs uppercase text-gray-500" }, window.__('Services')),
                                    react_1.default.createElement(RefinementList_1.default, { attribute: "services" })),
                                react_1.default.createElement("div", { className: "my-4" },
                                    react_1.default.createElement("h4", { className: "mb-2 font-medium text-xs uppercase text-gray-500" }, window.__('Zorgen')),
                                    react_1.default.createElement(RefinementList_1.default, { attribute: "care_options" }))))),
                        react_1.default.createElement("section", { className: "lg:col-span-2 xl:col-span-3" },
                            react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: children } }),
                            react_1.default.createElement(CurrentRefinements_1.default, null),
                            react_1.default.createElement(react_instantsearch_dom_1.InfiniteHits, { className: "mt-8 mb-16", hitComponent: Hit_1.default })))));
            } })));
}
exports.default = SearchIndex;
